import { InteractiveMapMarker } from 'components/InteractiveMap';
import useLocations from './useLocations';

export default function useLocationMarkers() {
  const { locations } = useLocations();
  const locationMarkers = locations
    ?.filter((location) => location.latitude && location.longitude)
    ?.map((location) => ({
      position: [location.latitude, location.longitude],
      label: location.name,
    })) as InteractiveMapMarker[];

  return locationMarkers;
}
